import { baseClient, getServiceURL } from '@/utils'
import { DEFAULT_LANGUAGE } from '@/constants'
import { ApiCaller } from '@front/utils'

const fetchLanguages = async ({ lang }) => {
	let languages
	const data = await ApiCaller.call('v2', "GET", `languages/${lang}`)
	languages = { data }
	return languages
}

const fetchEprojectTranslations = (lang = DEFAULT_LANGUAGE) => {
	return baseClient.get(`${getServiceURL('masters')}/v1/keys/domains/fr-eproject/files`, {
		params: {
			lang
		}
	})
}

const fetchWidgetsTranslations = (lang = DEFAULT_LANGUAGE) => {
	return baseClient.get(`${getServiceURL('masters')}/v1/keys/domains/fr-widgets/files`, {
		params: {
			lang
		}
	})
}

const fetchFrontTranslations = (lang = DEFAULT_LANGUAGE) => {
	return baseClient.get(`${getServiceURL('masters')}/v1/keys/domains/common-front/files`, {
		params: {
			lang
		}
	})
}

export default {
	fetchLanguages,
	fetchEprojectTranslations,
	fetchWidgetsTranslations,
	fetchFrontTranslations
}
